/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(function () {
	  (0, _module.anchorLink)();
	})();
	
	(function () {
	  (0, _module.pageTop)();
	})();
	
	(function () {
	  (0, _module.showYouTubeModal)();
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var breakPointSm = 641;
	var breakPointMd = 768;
	var breakPointLg = 1024;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowScrollPos = 0;
	
	function _vwSP(size) {
	  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 768;
	
	  windowWidth = window.innerWidth;
	  return size / base * windowWidth;
	}
	
	function _vwPC(size) {
	  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1920;
	
	  windowWidth = window.innerWidth;
	  return size / base * windowWidth;
	}
	
	// ------------------------------------------------------------------------
	// スムーススクロール
	// ------------------------------------------------------------------------
	var anchorLink = function anchorLink() {
	  $('a.scroll[href^="#"]').on('click', function () {
	    var linkSpeed = 400;
	    var linkHref = $(this).attr('href');
	    var linkTarget = $(linkHref == '#' || linkHref == '' ? 'html' : linkHref);
	    var linkPosition = linkTarget.offset().top;
	    var linkAdjust = 0;
	    $('html, body').animate({ scrollTop: linkPosition - linkAdjust }, linkSpeed, 'swing');
	    return false;
	  });
	};
	
	// ------------------------------------------------------------------------
	// ページトップの表示・非表示
	// ------------------------------------------------------------------------
	var pageTop = function pageTop() {
	  var scrollHeight = void 0;
	  var scrollPos = void 0;
	  var footerHeight = void 0;
	  var footerHeightAdjust = void 0;
	
	  $(window).on('load scroll', function () {
	    if ($(this).scrollTop() > 300) {
	      $('.st-PageTop').fadeIn();
	    } else {
	      $('.st-PageTop').fadeOut();
	    }
	
	    scrollHeight = $(document).height();
	    scrollPos = $(window).height() + $(window).scrollTop();
	    if (windowWidth < breakPointSm) {
	      footerHeightAdjust = _vwSP(43) + _vwSP(30); //PageTopボタンのFooter停止位置＋fixed時のBottom値
	    } else if (windowWidth >= breakPointSm && windowWidth < breakPointLg) {
	      footerHeightAdjust = 43 + 30; //PageTopボタンのFooter停止位置＋fixed時のBottom値
	    } else {
	      footerHeightAdjust = _vwPC(43) + _vwPC(30); //PageTopボタンのFooter停止位置＋fixed時のBottom値
	    }
	    footerHeight = $('footer').innerHeight() - footerHeightAdjust;
	
	    if (scrollHeight - scrollPos <= footerHeight) {
	      $('.st-PageTop').removeClass('fixed');
	    } else {
	      $('.st-PageTop').addClass('fixed');
	    }
	  });
	};
	
	// ------------------------------------------------------------------------
	// YouTube動画モーダル表示
	// ------------------------------------------------------------------------
	var showYouTubeModal = function showYouTubeModal() {
	  $('.video_link').on('click', function () {
	    var youtubeID = $(this).attr('data-youtube-id');
	    var listID = $(this).attr('data-youtube-list');
	    var html = '';
	
	    //背景コンテンツ固定
	    windowScrollPos = $(window).scrollTop();
	    $('body').addClass('fixed').css({ 'top': -windowScrollPos });
	
	    //モーダルボックス生成
	    if (listID.length) {
	      html = '<iframe width="800" height="450" src="https://www.youtube.com/embed/videoseries?list=' + listID + '&autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
	    } else {
	      html = '<iframe width="800" height="450" src="https://www.youtube.com/embed/' + youtubeID + '?autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
	    }
	    $('.sw-Modal .sw-Modal_Container .video_inner').append(html);
	    $('.sw-Modal').fadeIn(300);
	
	    return false;
	  });
	
	  //モーダルクローズ
	  function modalClose() {
	    //背景コンテンツ固定解除
	    $('body').removeClass('fixed').css({ 'top': '' });
	    $(window).scrollTop(windowScrollPos);
	
	    //モーダルボックス非表示
	    $('.sw-Modal').fadeOut(200);
	
	    //コンテンツ破棄
	    setTimeout(function () {
	      $('.sw-Modal .sw-Modal_Container .video_inner').html('');
	    }, 300);
	  }
	
	  $('.sw-Modal .btn_close').on('click', function () {
	    modalClose();
	    return false;
	  });
	
	  $(document).on('click', '.sw-Modal_Wrapper', function () {
	    modalClose();
	    return false;
	  });
	};
	
	exports.anchorLink = anchorLink;
	exports.pageTop = pageTop;
	exports.showYouTubeModal = showYouTubeModal;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.bundle.js